
import React from 'react'
import { Container, Tabs, Tab, Button } from 'react-bootstrap'
import { CATEGORIES_COLLECTION } from '../../firebase'
import { useHistory, useParams } from 'react-router';

const DeleteCategory = () => {

    const { id } = useParams()

    const history = useHistory()

    const handleDelete = () => {
        CATEGORIES_COLLECTION.doc(id).delete()
            .then(() => {
                alert("Uspješno obrisano 👍")
                history.push('/preview-category')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="delete-category" className="mb-3" transition={false}>
                    <Tab eventKey="preview-category" title={<div onClick={() => history.push('/preview-category')}>Pregled kategorija</div>} />
                    <Tab eventKey="add-category" title={<div onClick={() => history.push('/add-category')}>Dodaj</div>} />
                    <Tab eventKey="edit-category" title='Uredi' disabled />
                    <Tab eventKey="delete-category" title='Obriši'>
                        <Button variant="danger" onClick={handleDelete}>Obriši</Button>
                    </Tab>
                </Tabs>
            </Container>
        </>
    )
}

export default DeleteCategory
